import { render, staticRenderFns } from "./IdeaScoreCards.vue?vue&type=template&id=f91175c8"
import script from "./IdeaScoreCards.vue?vue&type=script&lang=js"
export * from "./IdeaScoreCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports